// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { creditCardDetailsEntryStyles } from "@conklin/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import IconNotificationInfo from "@conklin/XDL/Icons/IconNotificationInfo";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

creditCardDetailsEntryStyles.creditCardDetailsContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 16px 22px;
        ${xScreen("lte", "xs")} {
            grid-template-columns: repeat(6, minmax(0, 1fr));
        }
    `,
};

creditCardDetailsEntryStyles.creditCardInformation = {
    variant: "h6",
    css: css`
        grid-column: 1/5;
        margin-bottom: -8px;
        ${xScreen("lte", "xs")} {
            grid-column: 1/7;
        }
    `,
};

creditCardDetailsEntryStyles.cardHolderNameGridItem = {
    css: css`
        grid-column: 1/3;
        ${xScreen("lte", "xs")} {
            grid-column: 1/4;
        }
    `,
};

creditCardDetailsEntryStyles.cardNumberGridItem = {
    css: css`
        grid-column: 3/5;
        ${xScreen("lte", "xs")} {
            grid-column: 4/7;
        }
    `,
};
creditCardDetailsEntryStyles.cardTypeGridItem = {
    css: css`
        grid-column: span 4;
    `,
};
creditCardDetailsEntryStyles.cardTypeTokenExLabel = {
    weight: fontConfig.weight.bold,
    css: css`
        margin-right: 8px;
    `,
};

creditCardDetailsEntryStyles.expirationMonthGridItemOnePageCheckout = {
    css: css`
        grid-column: 1/2;
        ${xScreen(768, 1300)} {
            grid-column: 1/3;
        }
        ${xScreen("lte", "xs")} {
            grid-column: 1/3;
        }
    `,
};

creditCardDetailsEntryStyles.expirationYearGridItemOnePageCheckout = {
    css: css`
        grid-column: 2/3;
        ${xScreen(768, 1300)} {
            grid-column: 3/5;
        }
        ${xScreen("lte", "xs")} {
            grid-column: 3/5;
        }
    `,
};

creditCardDetailsEntryStyles.securityCodeGridItemOnePageCheckout = {
    css: css`
        grid-column: 3/4;
        ${xScreen(768, 1300)} {
            grid-column: 1/3;
        }
        ${xScreen("lte", "xs")} {
            grid-column: 5/7;
        }
    `,
};

creditCardDetailsEntryStyles.expirationYearSelect = {
    cssOverrides: {
        formField: css`
            margin-top: 21px;
        `,
    },
};
creditCardDetailsEntryStyles.securityCodeHelpImage = {
    mergeCss: true,
    css: css`
        height: auto;
        width: 100%;
    `,
};

creditCardDetailsEntryStyles.hintLink = {
    ...createLinkIconStyles(IconNotificationInfo, "small", "left", false, undefined, undefined, {
        css: css`
            opacity: 1;
            margin-left: 4px;
        `,
    }),
};

const labelStyles = {
    css: css`
        white-space: nowrap;
    `,
};

creditCardDetailsEntryStyles.securityCodeTokenExFrame = {
    labelProps: labelStyles,
};

creditCardDetailsEntryStyles.securityCodeSpreedlyFrame = {
    labelProps: labelStyles,
};

creditCardDetailsEntryStyles.securityCodeText = {
    labelProps: labelStyles,
};

creditCardDetailsEntryStyles.expirationMonthSelect = {
    labelProps: labelStyles,
};
